import styled from "styled-components";
export const RechargeViewWrapper = styled.div`
  margin: 12px 50px 0;
  border-radius: 6px;
  border: 1px solid ${(p) => p.theme["color-line-1"]};
  position: relative;
  height: calc(100vh - 170px);
  min-height: 479px;
  background: ${(p) => p.theme["theme-1"]};
  pointer-events: auto;
`;
export const RechargeContentWrapper = styled.div`
  display: flex;
  height: 100%;
`;
export const LeftContent = styled.div`
  flex: 1 1 0%;
  overflow: hidden;
  .renderbus-ui-tab {
    border-radius: 6px;
    background: ${(p) => p.theme["theme-1"]};
  }
`;
export const RightContent = styled.div`
  width: 220px;
`;
